import { createStyles, Drawer, makeStyles, Typography } from '@material-ui/core';
import React, { useCallback, useEffect } from 'react';
import { CommentsContext } from "../context/comments.js";
import { useLocalization, useViewerSettings, useViewerState } from "../hooks/index.js";
import { Comment, CreateComment } from "./comment/index.js";
import { PageList, Thumbnails } from "./index.js";
export const THUMBNAIL_PADDING = 16;
export const THUMBNAIL_NAME = 'Thumbnail';
export const THUMBNAIL_CONTAINER_ID = 'sn-document-viewer-thumbnails';
export const PAGE_PADDING = 8;
export const PAGE_NAME = 'Page';
export const PAGE_CONTAINER_ID = 'sn-document-viewer-pages';
const useStyles = makeStyles(() => {
  return createStyles({
    mainWrapper: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1
    },
    layout: {
      display: 'flex',
      flexGrow: 1,
      width: '100%',
      overflow: 'hidden',
      zIndex: 0,
      position: 'relative'
    },
    commentContainer: {
      display: 'flex',
      flexFlow: 'column',
      padding: '15px',
      justifyContent: 'space-between',
      alignItems: 'center',
      overflow: 'auto'
    }
  });
});
export const DocumentViewerLayout = () => {
  const classes = useStyles();
  const viewerState = useViewerState();
  const localization = useLocalization();
  const viewerSettings = useViewerSettings();
  const scrollToImage = useCallback(({
    containerId,
    index,
    itemName,
    padding,
    smoothScroll
  }) => {
    const container = document.getElementById(containerId);
    const item = document.querySelector(`.${itemName}`);
    if (container && container.scrollTo && item) {
      container.scrollTo({
        top: (item.clientHeight + padding * 4) * (index - 1),
        behavior: smoothScroll ? 'smooth' : 'auto'
      });
    }
  }, []);
  const scrollTo = useCallback((index, smoothScroll = true) => {
    scrollToImage({
      containerId: PAGE_CONTAINER_ID,
      itemName: PAGE_NAME,
      padding: PAGE_PADDING,
      index,
      smoothScroll
    });
    scrollToImage({
      containerId: THUMBNAIL_CONTAINER_ID,
      itemName: THUMBNAIL_NAME,
      padding: THUMBNAIL_PADDING,
      index,
      smoothScroll
    });
  }, [scrollToImage]);
  useEffect(() => {
    const observer = viewerState.pageToGo.subscribe(({
      page
    }) => {
      scrollTo(page);
    });
    return () => observer.dispose();
  }, [scrollTo, viewerState.pageToGo]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.mainWrapper
  }, viewerSettings.renderAppBar(), /*#__PURE__*/React.createElement("div", {
    className: classes.layout
  }, /*#__PURE__*/React.createElement(Drawer, {
    variant: 'persistent',
    open: viewerState.showThumbnails,
    anchor: "left",
    SlideProps: viewerSettings.drawerSlideProps,
    PaperProps: {
      style: {
        position: 'relative',
        width: viewerState.showThumbnails ? '200px' : 0,
        height: '100%',
        overflow: 'hidden'
      }
    }
  }, viewerState.showThumbnails && /*#__PURE__*/React.createElement(Thumbnails, {
    onPageClick: index => scrollTo(index)
  })), /*#__PURE__*/React.createElement(PageList, {
    onPageClick: index => scrollTo(index)
  }), /*#__PURE__*/React.createElement(Drawer, {
    variant: 'persistent',
    open: viewerState.showComments,
    anchor: "right",
    SlideProps: viewerSettings.drawerSlideProps,
    PaperProps: {
      style: {
        position: 'relative',
        width: viewerState.showComments ? '340px' : 0,
        height: '100%',
        overflow: 'hidden'
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.commentContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, localization.commentSideBarTitle), /*#__PURE__*/React.createElement(CreateComment, null), /*#__PURE__*/React.createElement(CommentsContext.Consumer, null, commentsContext => commentsContext.comments.map(comment => /*#__PURE__*/React.createElement(Comment, {
    key: comment.id,
    comment: comment
  })))))));
};
//# sourceMappingURL=document-viewer-layout.js.map